import $ from 'jquery';

const touch = {
  /**
   * @type {Object}
   */
  selectors: {
    linksToDisable: 'a[data-disable-href-touch=true]'
  },

  $body: null,

  init: function() {
    var self = this;

    this.$body = $('body');
    this.hasTouch = this.hasTouchFunc();

    for (
      var eventName, newEventName, i = 0, len = this.addNotTouchEvents.length;
      i < len;
      i++
    ) {
      eventName = this.addNotTouchEvents[i];
      newEventName = this.addNotTouchEvents[i] + '-not-touch';

      $.event.special[newEventName] = {
        delegateType: eventName,
        bindType: eventName,
        handle: function(event) {
          var handleObj = event.handleObj;
          var ret = null;

          if (!self.isLastEventTouch) {
            ret = handleObj.handler.apply(this, arguments);
          }

          return ret;
        }
      };
    }

    // mouseenter and mouseleave are special $ events
    // We need to modify them in other way
    $.event.special['mouseenter-not-touch'] = {
      bindType: 'mouseover',
      delegateType: 'mouseover',
      handle: function() {
        var ret = null;

        if (!self.isLastEventTouch) {
          ret = $.event.special.mouseenter.handle.apply(this, arguments);
        }

        return ret;
      }
    };

    $.event.special['mouseleave-not-touch'] = {
      bindType: 'mouseout',
      delegateType: 'mouseout',
      handle: function() {
        var ret = null;

        if (!self.isLastEventTouch) {
          ret = $.event.special.mouseleave.handle.apply(this, arguments);
        }

        return ret;
      }
    };

    if (this.hasTouch) {
      this.$body.on('mousemove', $.proxy(this.mouseEventHappened, this));
      this.$body.on(
        'touchstart.bodyTouch',
        $.proxy(this.touchEventHappened, this)
      );
      this.touchEventHappened();
    } else {
      this.$body.addClass('is-desktop');
    }
  },
  mouseEventHappened: function() {
    this.$body.on(
      'touchstart.bodyTouch',
      $.proxy(this.touchEventHappened, this)
    );
    this.timesMousemoveCalled++;
    if (this.isLastEventTouch && this.timesMousemoveCalled > 2) {
      this.$body.off(
        'click',
        this.selectors.linksToDisable,
        this.disableHrefOnTouch
      );
      this.$body.addClass('is-desktop');
      this.isLastEventTouch = false;
    }
  },

  touchEventHappened: function() {
    if (!this.isLastEventTouch) {
      this.$body.on(
        'click',
        this.selectors.linksToDisable,
        this.disableHrefOnTouch
      );
      this.$body.removeClass('is-desktop');
    }
    this.isLastEventTouch = true;
    this.timesMousemoveCalled = 0;
    this.$body.off('.bodyTouch');
  },

  disableHrefOnTouch: function(e) {
    // call e.preventDefault(); to prevent redirection on link
    e.preventDefault();

    return false;
  },

  hasTouchFunc: function() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  },

  hasTouch: false,

  isLastEventTouch: false,

  addNotTouchEvents: [
    'mouseover',
    'mousemove',
    'mousedown',
    'mouseup',
    'click',
    'mouseout'
  ],

  timesMousemoveCalled: 0
};

touch.init();

export let hasTouch = touch.hasTouch;



/** WEBPACK FOOTER **
 ** ./legacy/home24/core/touch.js
 **/